<div class="w-full h-full flex align-items-center justify-content-center">
    Chargement en cours...
</div>